/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const CalendarDates = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 13 12" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <defs><path id="a" d="M416 640v-1h12v1z" /><path id="b" d="M416 650v-1h13v1z" /><path id="c" d="M416 650v-11h1v11z" /><path id="d" d="M428 650v-11h1v11z" /><path id="e" d="M419 640v-2h1v2z" /><path id="f" d="M419 647v-1h1v1z" /><path id="g" d="M419 645v-1h1v1z" /><path id="h" d="M419 643v-1h1v1z" /><path id="i" d="M421 647v-1h1v1z" /><path id="j" d="M421 645v-1h1v1z" /><path id="k" d="M421 643v-1h1v1z" /><path id="l" d="M423 647v-1h1v1z" /><path id="m" d="M423 645v-1h1v1z" /><path id="n" d="M423 643v-1h1v1z" /><path id="o" d="M425 645v-1h1v1z" /><path id="p" d="M425 643v-1h1v1z" /><path id="q" d="M425 640v-2h1v2z" /></defs><use href="#a" transform="translate(-416 -638)" /><use href="#b" transform="translate(-416 -638)" /><use href="#c" transform="translate(-416 -638)" /><use href="#d" transform="translate(-416 -638)" /><use href="#e" transform="translate(-416 -638)" /><use href="#f" transform="translate(-416 -638)" /><use href="#g" transform="translate(-416 -638)" /><use href="#h" transform="translate(-416 -638)" /><use href="#i" transform="translate(-416 -638)" /><use href="#j" transform="translate(-416 -638)" /><use href="#k" transform="translate(-416 -638)" /><use href="#l" transform="translate(-416 -638)" /><use href="#m" transform="translate(-416 -638)" /><use href="#n" transform="translate(-416 -638)" /><use href="#o" transform="translate(-416 -638)" /><use href="#p" transform="translate(-416 -638)" /><use href="#q" transform="translate(-416 -638)" />
      </g>
    </svg>
  </span>
);

CalendarDates.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

CalendarDates.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default CalendarDates;
